export const SHOP_RESPONSIVE_MARKER = 'shop-responsive-fit';

const responsiveHead = `
<style id="${SHOP_RESPONSIVE_MARKER}">
  html {
    font-size: clamp(8px, min(2.75vw, 4.85vh), 15px);
    -webkit-text-size-adjust: 100%;
  }
  html, body {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  body {
    margin: 0;
  }
  .card, .shop-root {
    min-height: 0 !important;
    max-height: 100%;
  }
  .headline, .title, .eyebrow, .subtitle, .coins, .bullet, .cta, .discount, .old-price {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
</style>`;

/** Legacy fit script caused slow first paint in preview iframe. */
function stripLegacyFitScript(html: string): string {
    return html.replace(new RegExp(`<script id="${SHOP_RESPONSIVE_MARKER}-script">[\\s\\S]*?</script>\\s*`, 'g'), '');
}

export function injectShopResponsiveHtml(html: string): string {
    const cleaned = stripLegacyFitScript(html);
    if (cleaned.includes(SHOP_RESPONSIVE_MARKER)) return cleaned;
    return cleaned.includes('</head>')
        ? cleaned.replace('</head>', `${responsiveHead}\n</head>`)
        : `${responsiveHead}${cleaned}`;
}
